export enum EmployerSubmissionTypeEnum {
  EmployerSelfEnrolment = 1,
  UpdateAddress = 2,
  UpdateContacts = 3,
  UpdateEmploymentStatus = 4
}
